import cn from 'classnames';
import { IconProps } from 'components/Shared/Icon/index';
import { iconStyles } from 'components/Shared/Icon/iconStyles';
import styles from './styles.scss';

export const IconTag = (props: IconProps) => (
  <svg
    viewBox="0 0 22 22"
    className={cn(styles.base, iconStyles(props))}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="none" fillRule="evenodd" stroke="#FFF" strokeWidth="1.8" opacity=".5">
      <path d="M17.1892 4.1432c-.645-.6997-1.6903-.6997-2.3348 0-.6444.7004-.6444 1.8372 0 2.5362.6445.7018 1.6897.7018 2.3348 0 .6438-.699.6438-1.8358 0-2.5362zM11.4147 1.459l-8.6162 9.366c-.3713.4028-.3713 1.0705 0 1.4734l6.8866 7.4853c.3713.403.983.4058 1.3563 0l8.617-9.3652c.1807-.1965.5016-.8122.5016-1.0884V3.4115c0-.4912-1.8508-2.4985-2.3001-2.4985L12.416.9145c-.2515 0-.8206.3488-1.0014.5445z" />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M5.623 7.8551c-2.3254-.4205-3.943-1.354-3.943-2.439 0-1.4785 3.0089-2.677 6.7197-2.677 3.712 0 6.7203 1.1985 6.7203 2.677 0 .283-.1095.5544-.3127.8106m-8.584 4.8366l4.8963 5.3715m-3.2648-7.162l4.8969 5.3722"
      />
    </g>
  </svg>
);
